<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section-news></section-news>
  </main>
</template>

<script>
import Hero from '@/components/Hero';
import News from '@/views//News/ListOfNews';

export default {
  data() {
    return {
      bgImg: 'Banner4-News-',
      subtitle: this.$t('nav.news'),
    };
  },
  components: {
    'section-hero': Hero,
    'section-news': News,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/News/Index.vue